import React from 'react';
import { XIcon } from 'lucide-react';
import { problemas } from '../data/problemas';
import { Emoji } from './Emoji';
export function Problema() {
  return <section className="w-full bg-forest-900 py-20" style={{
    paddingBottom: "0px",
    paddingTop: "23px"
  }} data-id="element-181" data-mp="2cwh5i5k9ccvd">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-182" data-mp="2rp9isqc5bbkb">
        <h2 className="font-display text-3xl font-extrabold leading-[1.05] tracking-tight text-cream sm:text-[2.5rem]" data-id="element-183" data-mp="2mv5bu72vr3j8">
          ¿Cuántos domingos más vas a terminar sin saber qué comer mañana?
        </h2>

        
        <p className="mt-4 font-display text-xl font-bold text-lime-400" data-id="element-184" data-mp="2wom599z3ugmd">
          No terminás nunca.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-cream/75" data-id="element-185" data-mp="3ajy7e2flb9db">
          Y lo peor no es el hambre… es esa sensación de que querés comer bien,
          organizarte, y salir del ciclo… pero la semana te vuelve a ganar.
        </p>
        <p className="mt-6 font-display text-xl font-extrabold text-lime-500 sm:text-2xl" data-id="element-186" data-mp="1bai0554sxio7">
          No es falta de ganas. No es falta de recetas. Es falta de un sistema.
        </p>
        

        <p className="mt-12 font-display text-sm font-bold uppercase tracking-[0.16em] text-cream/60" data-id="element-187" data-mp="3cpi5ipgcv8qp">
          Reconocés alguna de estas situaciones:
        </p>

        <ul className="mt-6 flex flex-col gap-3 text-left" data-id="element-188" data-mp="3lgighe8nvzzq">
          {problemas.map(problema => <li key={problema} className="flex items-center gap-4 rounded-xl border border-clay/45 bg-clay/[0.14] px-5 py-4" data-id="element-189" data-mp="3qfu0cw4brllj">
              <XIcon className="h-6 w-6 shrink-0 text-clay" strokeWidth={3.5} aria-hidden="true" data-id="element-190" data-mp="3veexuns6zr6a" />
              <span className="font-display text-[15px] font-bold leading-snug text-cream" data-id="element-191" data-mp="483rqd8bs083">
                {problema}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl text-[15px] leading-relaxed text-cream/70" data-id="element-192" data-mp="87w3szwxgoi7">
          Si te reconociste en aunque sea una de estas, lo que vas a leer ahora
          te cambia la semana para siempre.
        </p>

        <p className="mt-8 font-display text-2xl font-extrabold italic tracking-tight text-lime-400 sm:text-3xl" data-id="element-193" data-mp="3dbzj8iczsg7z">
          ¿Y si este fuera el último domingo que pasás así?
        </p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-gold/40 bg-forest-800 px-5 py-2.5 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-cream sm:text-sm" style={{
        fontSize: "10px",
        paddingTop: "0px",
        paddingBottom: "6px",
        paddingLeft: "22px",
        paddingRight: "0px",
        width: "335px",
        height: "32px"
      }} data-id="element-194" data-mp="3mcxqd9iq93us">
          <Emoji symbol="⭐" data-id="element-195" data-mp="9vj0vkezfy8t" />
          CLOSE THE GAP™ MEGAPACK COCINA LISTA
        </p>
      </div>
    </section>;
}